export default function Pending() {
  return (
    <div className="animate-pulse bg-gray-200 dark:bg-gray-700 p-2 min-w-20 rounded"></div>
  );
}
